import React, { useEffect, useState, useRef, useContext } from 'react';
import RoomList from './RoomList';
import ChatForm from './ChatForm';
import Conversation from './Conversation';
import SearchRooms from './SearchRooms';
import { useChat } from '../../../context/provider/ChatProvider'
import { Modal } from '../modal/Modal';
import { useModal } from '../../../hooks/useModal';
import { Fetch } from '../../../services/api';
import { notify } from '../../../utils/utils';
import { UserContext } from '../../../context/provider/UserProvider';
import { useGroups } from '../../../hooks/grupos/useGroups';
import { guardarFotoGrupoChat } from '../../../utils/utils';


const ChatContainer = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const fotoDefault = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3aYoBJuTIzugm2Gmdkz6oY9VaHqYdHRUznyruA2s-mA&s'
    const [query, setQuery] = useState('');
    const [isNavOpen, setIsNavOpen] = useState();
    const { currentRoom } = useChat();
    const [ isOpenModalGrupo, openModalGrupo, closeModalGrupo ] = useModal()
    const classNameInput = "text-white h-[30px] rounded px-4 w-full bg-zinc-900 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"


    const [ fotoFile, setFotoFile ] = useState(null); 
    const [ fotoGrupo, setFotoGrupo ] = useState(fotoDefault);
    const inputFoto = useRef();
    const {
        grupo,
        obtenerDatosGrupo,
        guardarEditarGrupo,
        editarValorGrupo
    } = useGroups();

    const onSelectFile = e => {
        if (!e.target.files || e.target.files.length === 0) {
            return
        }
        const objectUrl = URL?.createObjectURL(e.target.files[0])
        setFotoFile(e.target.files[0])
        setFotoGrupo(objectUrl)
    }
    
    const configuracionGrupo = async ()=> {
        const guardoFoto = fotoFile === null ? [{isValid: true, urlImagen: ''}]  :  await guardarFotoGrupoChat(fotoFile,{nomCarpeta:'teguio',nomSubcarpeta: 'fotos-comunidad', nomArchivo: currentRoom.id})
        if(guardoFoto[0].isValid){
            const isValid = await guardarEditarGrupo(guardoFoto[0].urlImagen)
            if(isValid){
                await currentRoom.listarGruposPorUID()
                closeModalGrupo()
            }
        }        
    }

    return (

        <div className=' flex  h-full '>
            <RoomList 
                query={ query }
                isNavOpen={ isNavOpen }
                setIsNavOpen={ setIsNavOpen }
            />
            <div className=' flex flex-col p-2 w-full lg:w-[65%] lg:pt-0'>
                <div className=' h-full flex flex-col'>
                    {
                        ! currentRoom ? 
                        
                        <div className='m-auto text-2xl text-center '>¡Bienvenido a Chat de BEEX!<br/> Chatea con los miembros de los grupos.<br/> </div>
                        :
                        <>
                            <div
                                className=' justify-between items-center flex center border-b border-gray-800 rounded-l p-1 text-center '
                                style={{background:'linear-gradient(0deg, rgba(10,22,40,1) 0%, rgba(224,230,224,0) 54%, rgba(10,22,40,1) 100%)'}}
                            >
                                <div className='flex lg:flex-col lg:items-center'>
                                    <img
                                        className='h-12 w-12 rounded-full '
                                        key={currentRoom.id}
                                        alt='room-img'
                                        src={`${currentRoom?.urlImageRoom}` || fotoGrupo}
                                    />
                                    <div className='px-2 flex flex-col  text-left'>
                                        <div className='text-white text-xl lg:text-xs'>{ currentRoom.nameRoom }</div>
                                        <div className='text-white text-xs lg:whitespace-nowrap '>{ currentRoom.descriptionRoom || 'Sin descripción'}</div>
                                    </div>
                                </div>

                                <div className='flex lg:h-full lg:items-start'>
                                    <SearchRooms />
                                    <button 
                                        className=' hover:text-gray-500 text-2xl pl-5 pr-2 fa fa-ellipsis-v'
                                        onClick={async () => {
                                            await obtenerDatosGrupo(currentRoom)
                                            setFotoGrupo(currentRoom.urlImageRoom)
                                            openModalGrupo()
                                        }}
                                    />
                                </div>
                            </div>
                            <Conversation />
                            <ChatForm />
                        </>

                    }
                </div>
            </div>

            
        {/* </ChatAppContainer> */}
                <Modal
                    isOpen={isOpenModalGrupo}
                    closeModal={closeModalGrupo}
                    action={async () => {
                        await configuracionGrupo();
                    }}
                    title={`Editar Grupo [${currentRoom?.nameRoom }]`}
                    spinner={{}}
                    textButtons={{ confirm: 'Guardar', denied: 'Cerrar' }}
                    validButton={{ confirm: true, denied: true }}
                >
                    <div className="flex  items-center w-[400px] justify-center" key={currentRoom?.nameRoom}>
                        <div className='flex  flex-col text-center justify justify-center'>
                            <label htmlFor="file-1"> 
                                <input
                                    ref={inputFoto}
                                    type="file"
                                    name="file-1"
                                    id="file-1"
                                    className="inputfile inputfile-1 hidden" accept='.jpg,.png'
                                    onChange={onSelectFile}
                                />
                                <img
                                    key={currentRoom?.nameRoom}
                                    className='rounded-full w-[250px] h-[250px] mb-1 lg:w-[150px] lg:h-[150px] border border-gray-500 cursor-pointer '
                                    // src={fotoGrupo.includes('?') 
                                    //     ? `${fotoGrupo}&timestamp=${new Date().getTime()}`
                                    //     : `${fotoGrupo}`}
                                    src={fotoGrupo}
                                    alt=''
                                />
                                <i className="fa fa-image iborrainputfile text-[#FFFFFF] text-xl bg-green-600 px-2 rounded cursor-pointer hover:bg-green-300"></i> 
                            </label>                            
                            <div className='px-2 flex flex-col  text-left'>
                                <span>Nombre Grupo</span>
                                <input
                                    className={` ${classNameInput} caret-white`}
                                    value={grupo.NomGrupo||''}
                                    onChange={(e)=>editarValorGrupo("NomGrupo",e.target.value)}
                                /> 
                                <span>Descripción</span>
                                <input
                                    className={` ${classNameInput} caret-white `}
                                    value={grupo.Descripcion}
                                    onChange={(e)=>editarValorGrupo("Descripcion",e.target.value)}
                                
                                /> 
                            </div>
                        </div>
                    </div>
                </Modal> 
        </div>
    );
};
export default ChatContainer;